import { render, staticRenderFns } from "./authorizeRegistnoAction.vue?vue&type=template&id=618e86c3&scoped=true"
import script from "./authorizeRegistnoAction.vue?vue&type=script&lang=js"
export * from "./authorizeRegistnoAction.vue?vue&type=script&lang=js"
import style0 from "./authorizeRegistnoAction.vue?vue&type=style&index=0&id=618e86c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618e86c3",
  null
  
)

export default component.exports